import { ContextMenuConfig } from "@components/ContextMenu";

export interface TimelineContextMenuContext {
    currentDay: Date;
    timeZone: string;
    filter: string;
    jobsCount: number;
    isTodayInTimeZone: boolean;
}

interface BuildTimelineContextMenuParams {
    //   onRefreshJobs: (context: TimelineContextMenuContext) => void | Promise<void>;
    onCreateJob: (context: TimelineContextMenuContext) => void | Promise<void>;
    onChangeFilter: (filter: "all" | "residential" | "commercial") => void;
    //   onCopySummary?: (summary: string, context: TimelineContextMenuContext) => void | Promise<void>;
}

export const buildTimelineContextMenu = ({
    //   onRefreshJobs,
    onCreateJob,
    onChangeFilter,
    //   onCopySummary,
}: BuildTimelineContextMenuParams): ContextMenuConfig<TimelineContextMenuContext> => ({
    items: [
        // {
        //   type: "action",
        //   id: "refresh-jobs",
        //   label: "Refresh jobs",
        //   onSelect: onRefreshJobs,
        // },
        {
            type: "action",
            id: "create-job",
            label: "Create job for this day",
            onSelect: onCreateJob,
        },
        // {
        //     type: "submenu",
        //     id: "view",
        //     label: "View",
        //     items: [
        //         {
        //             type: "action",
        //             id: "view-all",
        //             label: "Show all jobs",
        //             disabled: (context) => context.filter === "all",
        //             onSelect: () => onChangeFilter("all"),
        //         },
        //         {
        //             type: "action",
        //             id: "view-residential",
        //             label: "Show residential jobs",
        //             disabled: (context) => context.filter === "residential",
        //             onSelect: () => onChangeFilter("residential"),
        //         },
        //         {
        //             type: "action",
        //             id: "view-commercial",
        //             label: "Show commercial jobs",
        //             disabled: (context) => context.filter === "commercial",
        //             onSelect: () => onChangeFilter("commercial"),
        //         },
        //     ],
        // },
        // {
        //   type: "separator",
        // },
        // {
        //   type: "action",
        //   id: "copy-summary",
        //   label: "Copy day summary",
        //   onSelect: async (context) => {
        //     const summary = [
        //       `Date: ${formatDate(context.currentDay, context.timeZone, "yyyy-MM-dd")}`,
        //       `Time zone: ${context.timeZone}`,
        //       `Filter: ${context.filter}`,
        //       `Jobs: ${context.jobsCount}`,
        //     ].join("\n");

        //     if (onCopySummary) {
        //       await onCopySummary(summary, context);
        //       return;
        //     }

        //     await navigator.clipboard.writeText(summary);
        //   },
        // },
    ],
});